import { Box } from '@mui/material';
import { FormFieldsData, ModalForm } from 'framework/form';
import { SideDrawer } from 'framework/ui/mui-builder';
import InterruptionCreateFields from './InterruptionCreateFields';
import InterruptionDrawerSubmitButton from '../InterruptionDrawerSubmitButton';
import { getInterruptionCreateValidationSchema } from '../validation';
import useCreateTaskStatusPingInterruptionSubmit from './useCreateTaskStatusPingInterruptionSubmit';
import useTaskStatusPingInitialData from './useTaskStatusPingInitialData';
import { InterruptionCreateFormValues } from '../../types';

type TaskStatusPingInterruptionDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  onCreated?: () => void;
};

const DRAWER_CONTENT_SX = {
  width: '100%',
  minHeight: 200,
} as const;

const FORM_MESSAGE_CONTEXT = 'taskStatusPingInterruptionDrawer';

const TaskStatusPingInterruptionDrawer = ({ isOpen, onClose, onCreated }: TaskStatusPingInterruptionDrawerProps) => {
  const { createTaskStatusPing } = useCreateTaskStatusPingInterruptionSubmit();
  const { getInitialData } = useTaskStatusPingInitialData();

  const submit = async (values: FormFieldsData<InterruptionCreateFormValues>) => {
    await createTaskStatusPing(values);
  };

  return (
    <SideDrawer
      title="Task status ping"
      isOpen={isOpen}
      onClose={onClose}
      width={600}
      content={
        <Box sx={DRAWER_CONTENT_SX}>
          {isOpen ? (
            <ModalForm
              closeModal={onClose}
              modalOpen={isOpen}
              isCloseAfterSubmit={false}
              isHideDefaultButtons
              getDataFunc={getInitialData}
              getValidationSchemaFunc={getInterruptionCreateValidationSchema}
              submitFormFunc={submit}
              afterSubmit={{
                execute: onCreated,
              }}
              messageContext={FORM_MESSAGE_CONTEXT}
            >
              <InterruptionCreateFields />
              <InterruptionDrawerSubmitButton />
            </ModalForm>
          ) : null}
        </Box>
      }
    />
  );
};

export default TaskStatusPingInterruptionDrawer;
